module.exports = __webpack_public_path__ + "static/media/e-remove.59b10d4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/e-remove.svg
// module id = 1171
// module chunks = 0